<template>
  <b-button class="download-button">
    <i class="fa fa-download download-icon"></i>
  </b-button>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style>
.download-icon {
  font-size: 24px !important;
  cursor: pointer;
  transition: all 0.2s;
  color: rgb(28, 187, 140);
}
.download-button {
  background-color: inherit;
  border-radius: 10px;
  padding: 10px;
  border: 0px;
  transition: all 0.2s;
  width: 45px;
  height: 45px;
}
.download-button:hover .download-icon {
  transform: scale(1.3);
}
.download-button:hover {
  background-color: rgba(28, 187, 140, 0.1);
}
</style>
